module.exports = __webpack_public_path__ + "img/icon_home.3c1e8264.svg";